import React, { Component } from "react";
import axios from "axios";
import { Header, Message, Segment } from "semantic-ui-react";
import { DealerDocUploader } from "./DealerDocUploader";
import DealerCoi from "./DealerCoi";

const baseUrl = "dealer";

const dealerDocUrl = (docType) => {
  switch (docType) {
    case "dealerAch":
      return "dealer-ach";
    case "dealerCoi":
      return "dealer-coi";
    case "dealerContractAgreement":
      return "dealer-contract-agreement";
    case "dealerRecuperation":
      return "dealer-recuperation";
    case "dealerW9":
      return "dealer-w9";
    default:
      return null;
  }
};

export class DealerDocuments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      cois: [],
      error: null,
      dealerAch: null,
      dealerCoi: null,
      dealerContractAgreement: null,
      dealerRecuperation: null,
      dealerW9: null,
      reqResponse: null,
    };

    this.fetchData = this.fetchData.bind(this);
    this.onDocRemove = this.onDocRemove.bind(this);
    this.onDocUpload = this.onDocUpload.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    axios
      .get(`/profile/`)
      .then((res) => {
        const { data } = res;

        this.setState({
          loading: false,
          id: data.id,
          cois: [
            ...data.dealer_cois,
            ...data.pending_cois,
            ...data.archived_cois.map((d) => ({ ...d, archived: true })),
          ],
          dealerAch: data.dealer_ach ? data.dealer_ach : null,
          dealerCoi: data.dealer_coi ? data.dealer_coi : null,
          dealerContractAgreement: data.dealer_contract_agreement
            ? data.dealer_contract_agreement
            : null,
          dealerRecuperation: data.dealer_recuperation
            ? data.dealer_recuperation
            : null,
          dealerW9: data.dealer_w9 ? data.dealer_w9 : null,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }

  onDocUpload(e) {
    const { id } = this.state;
    const inputName = e.target.name;
    const doc = e.target.files[0];
    // the file

    const docUrl = dealerDocUrl(inputName);
    // for URL
    const data = new FormData();

    let fieldName = "";
    switch (inputName) {
      case "dealerAch":
        fieldName = "dealer_ach";
        break;
      case "dealerCoi":
        fieldName = "dealer_coi";
        break;
      case "dealerContractAgreement":
        fieldName = "dealer_contract_agreement";
        break;
      case "dealerRecuperation":
        fieldName = "dealer_recuperation";
        break;
      case "dealerW9":
        fieldName = "dealer_w9";
        break;
      default:
        return null;
    }

    data.append("dealer_id", id);
    data.append(fieldName, doc);

    this.setState({ loading: true });

    axios
      .post(`/images/${docUrl}/`, data)
      .then((res) => {
        this.setState({
          loading: false,
          [`${inputName}`]: res.data[fieldName],
        });
      })
      .catch((err) => {
        this.setState({ loading: false }, () => this.fetchData());
      });
  }

  onDocRemove(e, name) {
    e.preventDefault();
    const filename = this.state[name].filename;
    const docUrl = dealerDocUrl(name);

    this.setState({ loading: true });

    axios
      .delete(`/images/${docUrl}/${filename}/`)
      .then((res) => {
        this.setState({
          loading: false,
          [name]: null,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: "There was a problem removing the document. Please try again.",
        });

        setTimeout(() => {
          this.setState({
            error: null,
          });
        }, 3000);
      });
  }

  render() {
    const { loading, error, reqResponse } = this.state;

    return (
      <div>
        <Header
          as="h1"
          content="Documents"
          subheader="Manage your documents"
          dividing
        />
        {reqResponse ? (
          <Message
            icon={reqResponse.success ? "check" : "exclamation"}
            negative={!reqResponse.success}
            positive={reqResponse.success}
            header={reqResponse.header}
            content={reqResponse.message}
          />
        ) : null}
        <Segment loading={loading} className="no-style-segment">
          {/* ACH */}
          <DealerCoi
            dealerId={this.state.id}
            docs={this.state.cois}
            // isPartner={isPartner}
            // onFixedClick={this.onFixedClick}
            onRemoveClick={this.onDocRemove}
            fetchData={this.fetchData}
            // onDocApprove={this.onDocApprove}
            // onDocReject={this.toggleReject}
          />
          <DealerDocUploader
            doc={this.state.dealerAch}
            docType="dealerAch"
            header="ACH Agreement"
            onDocRemove={this.onDocRemove}
            onDocUpload={this.onDocUpload}
            url={
              this.state.dealerAch
                ? `/${baseUrl}/api/images/dealer-ach/${this.state.dealerAch.filename}`
                : null
            }
            sampleUrl="https://atwood-assets.s3.us-east-2.amazonaws.com/Vendor+ACH+Form.pdf"
          />
          {/* Contract Agreement */}
          <DealerDocUploader
            doc={this.state.dealerContractAgreement}
            docType="dealerContractAgreement"
            header="Contract Agreement"
            onDocRemove={this.onDocRemove}
            onDocUpload={this.onDocUpload}
            url={
              this.state.dealerContractAgreement
                ? `/${baseUrl}/api/images/dealer-contract-agreement/${this.state.dealerContractAgreement.filename}`
                : null
            }
            sampleUrl="https://atwood-assets.s3.us-east-2.amazonaws.com/Atwood+Rentals+Contract+Agreement.pdf"
          />
          {/* Recuperation */}
          <DealerDocUploader
            doc={this.state.dealerRecuperation}
            docType="dealerRecuperation"
            header="Recuperation"
            onDocRemove={this.onDocRemove}
            onDocUpload={this.onDocUpload}
            url={
              this.state.dealerRecuperation
                ? `/${baseUrl}/api/images/dealer-recuperation/${this.state.dealerRecuperation.filename}`
                : null
            }
            sampleUrl="https://atwood-assets.s3.us-east-2.amazonaws.com/Atwood+Rentals+Recuperation+Agreement.pdf"
          />
          {/* W9 */}
          <DealerDocUploader
            doc={this.state.dealerW9}
            docType="dealerW9"
            header="W9"
            onDocRemove={this.onDocRemove}
            onDocUpload={this.onDocUpload}
            url={
              this.state.dealerW9
                ? `/${baseUrl}/api/images/dealer-w9/${this.state.dealerW9.filename}`
                : null
            }
            sampleUrl="https://atwood-assets.s3.us-east-2.amazonaws.com/W9.pdf"
          />
          {/* COI */}
          {/* <DealerDocUploader
            doc={this.state.dealerCoi}
            docType="dealerCoi"
            header="Certificate of Insurance"
            onDocRemove={this.onDocRemove}
            onDocUpload={this.onDocUpload}
            url={
              this.state.dealerCoi
                ? `/${baseUrl}/api/images/dealer-coi/${this.state.dealerCoi.filename}`
                : null
            }
          /> */}
        </Segment>
      </div>
    );
  }
}
